module.exports = new __parcel__URL__("deployment-frequency-welcome.ccb12470.svg").toString();